/**
 * @description: 版权使用费与系统服务费报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="bxf-report">
        <div class="bxf-list" v-show="bxfShowList">
            <el-form :inline="true" :model="bxf_list_form" size="small">
                <el-form-item label="时间">
                    <div class="clearfix" ref="bxf_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="bxf_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="bxf_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="bxf_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="getRoom($event, 'bxf')">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="bxf_list_form.room_id" filterable clearable placeholder="请选择包厢号" :disabled="bxf_list_form.room_disabled">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单号">
                    <el-input v-model="bxf_list_form.order_id" placeholder="请输入订单号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="bxfInvoice">系统服务费发票申请</el-button>
                    <el-button type="primary" @click="bxfQuery">查询</el-button>
                    <el-button @click="bxfExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="bxf_list_table">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="create_time" label="时间"></el-table-column>
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="order_id" label="订单号"></el-table-column>
                <el-table-column prop="nickname" label="微信昵称"></el-table-column>
                <el-table-column prop="copyright_pay" label="版权使用费金额"></el-table-column>
                <el-table-column prop="server_pay" label="系统服务费金额"></el-table-column>
                <el-table-column prop="actual_pay" label="合计金额"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-7">版权使用费总额:</label>
                    <span class="list-total">{{bxf_copyright_pay}}</span>
                    <label class="list-label-7">系统服务费总额:</label>
                    <span class="list-total">{{bxf_server_pay}}</span>
                    <label class="list-label-4">合计金额:</label>
                    <span class="list-total">{{bxf_actual_pay}}</span>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="bxf_list_page"
                    :total="bxf_list_total"
                    @current-change="getBxfList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="bxf_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="bxf_export_sign" v-model="bxf_export_all" @change="bxfExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="bxf_export_ids" @change="bxfExportChange">
                    <el-checkbox label="create_time">时间</el-checkbox>
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="room_name">包厢号</el-checkbox>
                    <el-checkbox label="order_id">订单号</el-checkbox>
                    <el-checkbox label="nickname">微信昵称</el-checkbox>
                    <el-checkbox label="copyright_pay">版权使用费金额</el-checkbox>
                    <el-checkbox label="server_pay">系统服务费金额</el-checkbox>
                    <el-checkbox label="actual_pay">合计金额</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="bxf_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="bxf_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
        <div class="bxf-invoice" v-show="!bxfShowList">
            <h2>系统服务费发票申请</h2>
            <el-form ref="bxf_invoice_form" :model="bxf_invoice_form" label-width="120px">
                <el-form-item label="门店">
                    <el-select v-model="bxf_invoice_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开票月份">
                    <el-input v-model="bxf_month_names" class="el-ellipsis" clearable placeholder="请选择开票月份" @focus="bxfMonthSelect" @clear="bxfMonthDel"></el-input>
                </el-form-item>
                <el-form-item label="开票金额">
                    <el-input v-model="bxf_invoice_form.invoice_amount" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="公司名称">
                    <el-input v-model="bxf_invoice_form.invoice_company" placeholder="请输入公司名称"></el-input>
                </el-form-item>
                <el-form-item label="公司税号">
                    <el-input v-model="bxf_invoice_form.invoice_tax_num" placeholder="请输入公司税号"></el-input>
                </el-form-item>
                <el-form-item label="发票收件信息">
                    <el-input
                        type="textarea"
                        placeholder="请输入收件人、手机号、详细地址"
                        :autosize="{ minRows: 5 }"
                        v-model="bxf_invoice_form.address_infos">
                    </el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="bxf_invoice_form.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="bxfBackList">返回</el-button>
                    <el-button type="primary" @click="bxfInvoiceSub">提交申请</el-button>
                </el-form-item>
            </el-form>
            <!-- 开票月份弹窗 -->
            <div class="export-wrap" ref="bxf_month_alert">
                <el-row class="row-margin">
                    <label class="el-form-item__label">年份</label>
                    <el-date-picker
                        v-model="bxf_invoice_form.invoice_year"
                        type="year"
                        placeholder="选择年"
                        value-format="yyyy"
                        :picker-options="bxfPickerOptions"
                        @change="bxfBanMonth">
                    </el-date-picker>
                </el-row>
                <el-checkbox-group v-model="bxf_month_ids">
                    <el-checkbox label="1" :disabled="bxf_month_disabled.includes(1)">1月</el-checkbox>
                    <el-checkbox label="2" :disabled="bxf_month_disabled.includes(2)">2月</el-checkbox>
                    <el-checkbox label="3" :disabled="bxf_month_disabled.includes(3)">3月</el-checkbox>
                    <el-checkbox label="4" :disabled="bxf_month_disabled.includes(4)">4月</el-checkbox>
                    <el-checkbox label="5" :disabled="bxf_month_disabled.includes(5)">5月</el-checkbox>
                    <el-checkbox label="6" :disabled="bxf_month_disabled.includes(6)">6月</el-checkbox>
                    <el-checkbox label="7" :disabled="bxf_month_disabled.includes(7)">7月</el-checkbox>
                    <el-checkbox label="8" :disabled="bxf_month_disabled.includes(8)">8月</el-checkbox>
                    <el-checkbox label="9" :disabled="bxf_month_disabled.includes(9)">9月</el-checkbox>
                    <el-checkbox label="10" :disabled="bxf_month_disabled.includes(10)">10月</el-checkbox>
                    <el-checkbox label="11" :disabled="bxf_month_disabled.includes(11)">11月</el-checkbox>
                    <el-checkbox label="12" :disabled="bxf_month_disabled.includes(12)">12月</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_list: [],

                bxfShowList: true,
                bxf_list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    room_id: '',
                    order_id: ''
                },
				bxf_list_table: [],
				bxf_list_page: 1,
                bxf_list_total: 0,
                bxf_export_sign: false,
				bxf_export_all: false,
                bxf_export_ids: [],
                bxf_export_list: ['create_time', 'shop_name', 'room_name', 'order_id', 'nickname', 'copyright_pay', 'server_pay', 'actual_pay'],
                bxf_export_type: '1',
                bxf_copyright_pay: '',
                bxf_server_pay: '',
                bxf_actual_pay: '',
                bxf_invoice_form: {
                    shop_id: '',
                    invoice_amount: 0,
                    invoice_company: '',
                    invoice_tax_num: '',
                    address_infos: '',
                    remark: '',
                    invoice_year: ''
                },
                bxfPickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                bxf_month_ids: [],
                month_list: [{id: '1', name: '1月'}, {id: '2', name: '2月'}, {id: '3', name: '3月'}, {id: '4', name: '4月'}, {id: '5', name: '5月'}, {id: '6', name: '6月'}, {id: '7', name: '7月'}, {id: '8', name: '8月'}, {id: '9', name: '9月'}, {id: '10', name: '10月'}, {id: '11', name: '11月'}, {id: '12', name: '12月'}],
                bxf_month_names: '',
                bxf_month_disabled: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            }
        },
        mounted: function() {
            this.bxf_list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.bxf_list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.bxf_list_form.shop_id = this.shop_list[0].id;
                this.getRoom(this.shop_list[0].id);
                this.getBxfList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.bxf_list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.bxf_list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.bxf_list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.bxf_list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.bxf_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.bxf_list_form.start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.bxf_list_form.end_time = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 获取门店
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.bxf_list_form.room_id = '';
                    _this.bxf_list_form.room_disabled = true;
                } else {
                    _this.setShopDefaultTime(shop_id)
                    _this.bxf_list_form.room_id = '';
                    _this.bxf_list_form.room_disabled = false;
                    Vue.axios.post('Shop/getAllRoom', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },



            // 列表
            getBxfList(page) {
				const _this = this;

                _this.loading = true;
				Vue.axios.post('Cavca/getOrderList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.bxf_list_form.start_time,
                            "end_time": _this.bxf_list_form.end_time,
                            "shop_id": _this.bxf_list_form.shop_id,
                            "room_id": _this.bxf_list_form.room_id,
                            "order_id": _this.bxf_list_form.order_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.bxf_list_total = Number(res.data.response.result.count.total);
							_this.bxf_copyright_pay = res.data.response.result.count.copyright_pay;
							_this.bxf_server_pay = res.data.response.result.count.server_pay;
                            _this.bxf_actual_pay = res.data.response.result.count.actual_pay;
						}
						_this.bxf_list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			bxfQuery() {
				this.getBxfList(1);
            },
            // 导出
            bxfExportAll(val) {
				this.bxf_export_ids = val ? this.bxf_export_list : [];
				this.bxf_export_sign = false;
			},
			bxfExportChange(val) {
				const len = val.length;
				this.bxf_export_all = len === this.bxf_export_list.length;
				this.bxf_export_sign = len > 0 && len < this.bxf_export_list.length;
			},
            bxfExportSet() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "Cavca/exportOrderList"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.bxf_export_ids = res.data.response.result.export_fields;
                            _this.bxf_export_type = res.data.response.result.export_type;
                        } else {
                            _this.bxf_export_ids = _this.bxf_export_list;
                            _this.bxf_export_type = '1';
                        }
                        _this.bxfExportChange(_this.bxf_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.bxf_list_export)
                }, function() {
                    _this.bxfExport();
                });
            },
            bxfExport() {
                window.location.href = Vue.ctUrl + "Cavca/exportOrderList?" +
                    "&start_time=" + this.bxf_list_form.start_time +
                    "&end_time=" + this.bxf_list_form.end_time +
                    "&shop_id=" + this.bxf_list_form.shop_id +
                    "&room_id=" + this.bxf_list_form.room_id +
                    "&order_id=" + this.bxf_list_form.order_id +
                    "&export_fields=" + JSON.stringify(this.bxf_export_ids) +
                    "&export_type=" + this.bxf_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
            bxfInvoice() {
                this.bxf_invoice_form = {
                    shop_id: this.shop_list[0].id,
                    invoice_amount: 0,
                    invoice_company: '',
                    invoice_tax_num: '',
                    address_infos: '',
                    remark: '',
                    invoice_year: ''
                };
                this.bxf_month_ids = [];
                this.bxf_month_names = '';
                this.bxfShowList = false;
            },
            // 开票月份
            bxfMonthSelect() {
                const _this = this;
                const c_invoice_year = _this.bxf_invoice_form.invoice_year,
                    c_bxf_month_ids = _this.bxf_month_ids,
                    c_bxf_month_disabled = _this.bxf_month_disabled;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择年月', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.bxf_month_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.bxf_invoice_form.invoice_year = c_invoice_year;
                        _this.bxf_month_ids = c_bxf_month_ids;
                        _this.bxf_month_disabled = c_bxf_month_disabled;
                    }
                }, function() {
                    let arr = [];
                    _this.month_list.forEach(item => {
                        _this.bxf_month_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.bxf_month_names = arr.join(',');
                    _this.bxfInvoiceAmount();
                    layer.closeAll();
                }, function() {
                    _this.bxf_invoice_form.invoice_year = c_invoice_year;
                    _this.bxf_month_ids = c_bxf_month_ids;
                    _this.bxf_month_disabled = c_bxf_month_disabled;
                });
            },
            bxfMonthDel() {
				this.bxf_month_ids = [];
            },
            // 禁用月份
            bxfBanMonth() {
                const _this = this;

                _this.bxf_month_ids = [];
                Vue.axios.post('Cavca/getInvoiceDisabledMonth', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": _this.bxf_invoice_form.shop_id,
                            "invoice_year": _this.bxf_invoice_form.invoice_year
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.bxf_month_disabled = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 开票金额
            bxfInvoiceAmount() {
                const _this = this;

                Vue.axios.post('Cavca/getInvoiceAmount', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": _this.bxf_invoice_form.shop_id,
                            "invoice_year": _this.bxf_invoice_form.invoice_year,
                            "invoice_month": _this.bxf_month_ids
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.bxf_invoice_form.invoice_amount = res.data.response.result.amount;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 提交申请
            bxfInvoiceSub() {
                const _this = this;

                if(_this.bxf_invoice_form.invoice_amount === 0) {
                    layer.msg('开票金额为0，请重新选择开票月份');
                    return false;
                }
                Vue.axios.post('Cavca/ApplyInvoice', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": _this.bxf_invoice_form.shop_id,
                            "invoice_year": _this.bxf_invoice_form.invoice_year,
                            "invoice_month": _this.bxf_month_ids,
                            "invoice_company": _this.bxf_invoice_form.invoice_company,
                            "invoice_tax_num": _this.bxf_invoice_form.invoice_tax_num,
                            "address_infos": _this.bxf_invoice_form.address_infos,
                            "remark": _this.bxf_invoice_form.remark
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.getBxfList(_this.bxf_list_page);
                        layer.msg('申请成功');
                        _this.bxfShowList = true;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 返回列表
            bxfBackList() {
                this.bxfShowList = true;
            }
        }
    }
</script>
<style lang="less" scoped>
    .bxf-invoice {
        .el-form {
			width: 600px;
			.el-select {
				width: 100%;
			}
		}
    }
    .bxf-list {
        height: 100%;
    }
</style>